import { mainTable } from "../css/Common";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import DropDown from "../ReusableComponents/DropDown";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";

const LaundryPopup = ({ data, data1 }) => {

  return (
    <div class="w-full">
      <div class={mainTable.mainContentScreen}>
        <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
          <div class={mainTable.labelBold}>laundry Details</div>
          <hr class={mainTable.horizontalLine}></hr>
          <div class="grid gap-4 mb-6 md:grid-cols-4">
            <InputText
              inputType="text"
              title="Issue No"
              name="issueNo"
              disabled={true}
              classStar="text-red-500"
              content={data?.issueno}
            />

            <InputText
              inputType="date"
              title="Issue Date"
              classStar="text-red-500"
              name="date"
              content={data?.issuedate}
            />

            <DropDown
              title="Issued To"
              name="issuedTo"
              classStar="text-red-500"
              selectedOption={data?.MstStaffId || ""}
              options={Array.isArray(data1) ? data1 : []}
              placeholder="Select Issued To"
              // tabIndex="1"
              disabled={true}
            />

            <DropDown
              title="Issued By"
              name="issuedBy"
              classStar="text-red-500"
              selectedOption={data?.MstLaundryId || ""}
              options={Array.isArray(data1) ? data1 : []}
              placeholder="Select Issued By"
              // tabIndex="1"
            />
          </div>

          <table className="min-w-full border border-gray-300">
            <thead className="bg-[#3D6643] text-left">
              <tr>
                <th className="border px-0.5 py-2 w-[20px]">S.No</th>
                <th className="border px-4 py-2 w-[180px]">Item Type</th>
                <th className="border px-4 py-2 w-[180px]">Category</th>
                <th className="border px-4 py-2 w-[180px]">Name</th>
                <th className="border px-4 py-2 w-[80px]">Quantity</th>
                <th className="border px-4 py-2 w-[80px]">Rate</th>
                <th className="border px-4 py-2 w-[80px]">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border px-2 py-2 w-[1px]"></td>
                <td className="border px-4 py-2">
                  <AutoDropDown
                    placeholder="Select"
                    name="itemType"
                    Class="p-0"
                    selectedOption={data?.MstLaundryIssueId || ""}
                    options={Array.isArray(data1) ? data1 : []}
                  />
                </td>
                <td className="border px-4 py-2">
                  <AutoDropDown
                    placeholder="Select"
                    name="itemCategory"
                    Class="p-0"
                    selectedOption={data?.MstLaundryIssueId || ""}
                    options={Array.isArray(data1) ? data1 : []}
                  />
                </td>
                <td className="border px-4 py-2">
                  <AutoDropDown
                    placeholder="Select"
                    name="name"
                    Class="p-0"
                    selectedOption={data?.MstLaundryIssueId || ""}
                    options={Array.isArray(data1) ? data1 : []}
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    inputType="text"
                    name="quantity"
                    content={data?.MstLaundryIssueId || ""}
                    placeholder=""
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    inputType="text"
                    name="rate"
                    content={data?.MstLaundryIssueId || ""}
                    placeholder=""
                    // tabIndex="11"
                  />
                </td>
                <td className="border px-4 py-2">
                  <div className="flex gap-4 items-center justify-center">
                    <svg
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="w-6 h-6 text-black cursor-pointer"
                    >
                      <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                    </svg>
                    <svg
                      viewBox="0 0 1024 1024"
                      fill="currentColor"
                      className="w-6 h-6 text-black cursor-pointer"
                    >
                      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                    </svg>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <br></br>

          <TextArea
            title="Remarks"
            name="remarks"
            placeholder="Remarks"
            row={2}
            // tabIndex="1"
            maxLength={500}
            content={data?.MstLaundryIssueId || ""}
          />
          <div class="lg:col-span-3 sm:col-span-1">
            <div class={mainTable.input_richtextbox}></div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default LaundryPopup;
